import { X } from 'lucide-react'
import { useEffect } from 'react'

interface MobileSheetProps {
  open: boolean
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
}

export default function MobileSheet({ open, header, footer, children }: MobileSheetProps) {
  // prevent scroll when sheet is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [open])

  return (
    <div
      className={`fixed inset-0 z-50 bg-black/50 transition-opacity duration-300 ${
        open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      } md:hidden`}
    >
      {/* Sheet content */}
      <div
        className={`absolute left-0 top-0 w-full h-full bg-light transform transition-transform duration-300 flex flex-col ${
          open ? 'translate-y-0' : '-translate-y-full'
        }`}
        onClick={(e) => e.stopPropagation()} // prevent click inside from closing
      >
        {/* Header */}
        {header && header}

        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto">{children}</div>

        {footer && footer}
      </div>
    </div>
  )
}
